export class QueuedEvent {
    constructor({ transfer }) {
        this.name = 'queued';
        this.transfer = { ...transfer };
    }
    get data() {
        return {
            transfer: this.transfer,
        };
    }
}
